import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { VerticalSeparatedLayout } from '@bingads-webui-react/steps';
import { StepFooter } from '@bingads-webui-campaign-react/step-wizard-layout';
import { footerStyleOverrides } from '../styles/footer-style-overrides';

const {
  StepsContextProvider,
  StepContainer,
} = VerticalSeparatedLayout;

export const SingleStepLayout = React.memo(({
  children,
  wizardState: {
    i18n,
    stepInfo,
    isBusy,
    isReadOnlyUser,
  },
  wizardActions: {
    saveAndNavigateNext,
    cancelAndExit,
  },
  isCenteredLayout, classes,
}) => (
  <StepsContextProvider currentPath={stepInfo.id}>
    <div className={classNames(classes.wizardContainer, classes.wizardMainContainer)}>
      <div className={classNames(classes.wizardSingleStepLayoutStepScrollingContainer)}>
        <StepContainer
          className={isCenteredLayout ?
            classes.wizardSingleStepLayoutCenteredStepContainer :
            classes.wizardSingleStepLayoutStepContainer}
        >
          {children}
        </StepContainer>
      </div>
      <StepFooter
        className={classes.wizardFooter}
        styleOverrides={footerStyleOverrides}
        nextButtonText={i18n.getString(_TL_('Save'))}
        onNextClick={saveAndNavigateNext}
        isNextClickDisabled={isBusy || isReadOnlyUser}
        onCancelClick={cancelAndExit}
      />
    </div>
  </StepsContextProvider>
));

SingleStepLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  wizardState: PropTypes.shape({
    i18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    stepInfo: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
    isBusy: PropTypes.bool.isRequired,
    isReadOnlyUser: PropTypes.bool.isRequired,
  }).isRequired,
  wizardActions: PropTypes.shape({
    saveAndNavigateNext: PropTypes.func.isRequired,
    cancelAndExit: PropTypes.func.isRequired,
  }).isRequired,
  isCenteredLayout: PropTypes.bool,
  classes: PropTypes.shape({
    wizardContainer: PropTypes.string.isRequired,
    wizardMainContainer: PropTypes.string.isRequired,
    wizardSingleStepLayoutStepScrollingContainer: PropTypes.string.isRequired,
    wizardSingleStepLayoutCenteredStepContainer: PropTypes.string.isRequired,
    wizardSingleStepLayoutStepContainer: PropTypes.string.isRequired,
    wizardFooter: PropTypes.string.isRequired,
  }).isRequired,
};

SingleStepLayout.defaultProps = {
  isCenteredLayout: false,
};
